import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NotificationApi } from '../api/notification.api';

import { NotificationData, PushNotification } from '../../../interfaces/masters/notification' ;
import { AnyCnameRecord } from 'dns';

// Notification_Type_Id = 2 in Notifications_Type_Mst → "Second Opinion" notifications.
const SECOND_OPINION_NOTIFICATION_TYPE_ID = '2';

@Injectable()
export class NotificationService extends NotificationData {

    constructor(private api: NotificationApi) {
      super();
    }
  
    list(url: string): Observable<any> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<any>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<any> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:any): Observable<any> {
      return this.api.update(url,data);
    }
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }

    createSecondOpinionNotification(tenantId: any, title: string, message: string, createdBy: number): Observable<any> {
      const payload: PushNotification = {
        type: SECOND_OPINION_NOTIFICATION_TYPE_ID,
        tenantId,
        title,
        message,
        confirmFlag: 'N',
        createdAt: new Date(),
        createdBy,
        readAt: null,
        readBy: null,
        scheduleAt: null,
        sentAt: new Date(),
      };
      return this.api.add(`pushNotificationDet/${tenantId}/savePushNotificationDet`, payload);
    }
  }
  